import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import {
  CLIENTS,
  MANAGE_PLATFORM,
  CLIENT_CONFIGURATION,
  FILE_LIST,
  REDIRECT,
  HOME,
  NOT_AUTHORIZED,
  ERROR_PAGE,
  ALLOWED_ROLES,
  ALL_ROLES,
  CREDENTIAL_CONFIGURATION,
} from "../helpers/constants";

import Clients from "../pages/Clients";
import ManagePlatforms from "../pages/ManagePlatforms";
import ClientsConfigurations from "../pages/ClientsConfigurations";
import FileList from "../pages/FileList";
import Redirect from "../pages/Redirect";
import Home from "../pages/Home";

import Protected from "./ProtectedRoute";
import NotAuthorized from "../pages/NotAuthorized";
import Auth from "./AuthRoute";
import Error from "../pages/Error";
import NotFound from "../pages/NotFound";
import CredentialConfigurations from "../pages/CredentialConfigurations";

interface BrowserRouteProps {}

const BrowserRoute: React.FC<BrowserRouteProps> = ({}) => {
  return (
    <>
      <Routes>
        <Route element={<Protected allowedRoles={ALLOWED_ROLES} />}>
          <Route path={CLIENTS} element={<Clients />} />
          <Route
            path={CLIENT_CONFIGURATION}
            element={<ClientsConfigurations />}
          />
          <Route path={MANAGE_PLATFORM} element={<ManagePlatforms />} />
          <Route path={CREDENTIAL_CONFIGURATION} element={<CredentialConfigurations />} />

          
        </Route>
        <Route element={<Auth allowedRoles={ALLOWED_ROLES} />}>
          <Route path={HOME} element={<Home />} />
          <Route path={REDIRECT} element={<Redirect />} />
          
        </Route>
        <Route element={<Protected allowedRoles={ALL_ROLES} />}>
          <Route path={FILE_LIST} element={<FileList />} />
        </Route>
        <Route path={NOT_AUTHORIZED} element={<NotAuthorized />} />
        <Route path={ERROR_PAGE} element={<Error />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

export default BrowserRoute;
